import { createSlice } from "@reduxjs/toolkit";
import getTeleModPrices from "../../../rtk-apis/Setting/getTeleModPrices";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const getTeleModPricesSlice = createSlice({
    name: "getTeleModPricesSlice",
    initialState,
    reducers: {
        clearGetTeleModPricesState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTeleModPrices.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getTeleModPrices.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload;
                state.msg = payload.msg;
            })
            .addCase(getTeleModPrices.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default getTeleModPricesSlice.reducer;
export const { clearGetTeleModPricesState } = getTeleModPricesSlice.actions;
